import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {WebAppRoute} from "./web-app.route";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {CarouselModule} from "ngx-owl-carousel-o";
import {MatChipsModule} from "@angular/material/chips";
import {MatIconModule} from "@angular/material/icon";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {MatOptionModule} from "@angular/material/core";
import {MatDialogModule} from "@angular/material/dialog";
import {MatButtonModule} from "@angular/material/button";
import {MatInputModule} from "@angular/material/input";
import {UtilityModule} from "../common/modules/utility/utility.module";
import {ZXingScannerModule} from "@zxing/ngx-scanner";
import {MatTabsModule} from "@angular/material/tabs";
import {MatGridListModule} from "@angular/material/grid-list";
import {MatCardModule} from "@angular/material/card";
import {MatSelectModule} from "@angular/material/select";
import {SocialModule} from "../common/modules/social/social.module";

@NgModule({
  imports: [
    CommonModule,
    WebAppRoute,
    ReactiveFormsModule,
    CarouselModule,
    MatChipsModule,
    MatIconModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatOptionModule,
    MatDialogModule,
    MatButtonModule,
    MatInputModule,
    UtilityModule,
    ZXingScannerModule,
    MatTabsModule,
    MatGridListModule,
    MatCardModule,
    MatSelectModule,
    FormsModule,
    SocialModule
  ],
  exports: [],
  declarations: [],
  providers: [
    DatePipe
  ]
})
export class WebAppModule {
}
